{
  "title": "Clients",
  "search": "Search",
  "table": {
    "id": "ID",
    "name": "Name",
    "email": "Email",
    "suitabilityScore": "Suitability Score",
    "complianceIssue": "Compliance Issue",
    "createdAt": "Created At",
    "completedAt": "Completed At",
    "organization": "Organization",
    "province": "Province",
    "dateOfBirth": "Date of Birth",
    "notCompleted": "Not Completed",
    "custodianAccountNumbers": "Account #'s",
    "goals": "Goals",
    "portfolioRiskLevels": "Risk Levels",
    "marketValue": "Total Assets"
  }
}
